import script from "./LinkKnowledgeBase.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkKnowledgeBase.vue?vue&type=script&setup=true&lang=js"

import "./LinkKnowledgeBase.vue?vue&type=style&index=0&id=092c12b2&lang=scss"

const __exports__ = script;

export default __exports__